import { LoadingCircleModule } from './../../../shared/component/common/loading-circle/loading-circle.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { HeaderModule } from '../../../shared/component/common/header/header.module';
import { ButtonModule } from '../../../shared/component/common/button/button.module';
import { LabelModule } from '../../../shared/component/common/label/label.module';
import { BirthCityComponent } from './birth-city.component';
import { RetryModule } from '../../../shared/component/common/retry/retry.module';
import { RadioModule } from '../../../shared/component/common/radio/radio.module';
import { SearchModule } from '../../../shared/component/common/search/search.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HeaderModule,
    ButtonModule,
    LabelModule,
    ReactiveFormsModule,
    RetryModule,
    RadioModule,
    SearchModule,
    LoadingCircleModule
  ],
  declarations: [BirthCityComponent]
})
export class BirthCityComponentModule {}
